import { createVanIconComponent } from "./van"

const Delete = createVanIconComponent("delete")
export default Delete
